// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

var state = false;
var pos;

$('.js-drawer').click(function() {
  $('html').toggleClass('is-open');
  // $(".js-drawer").toggleClass("is-active");

  if (state == false) {
      pos = $(window).scrollTop();
      $('body').addClass('is-fixed').css({'top': -pos});
      state = true;
    } else {
      $('body').removeClass('is-fixed').css({'top': 0});
      window.scrollTo(0, pos);
      state = false;
    }
})

$(".js-overlay").click(function() {
  if($('html').hasClass('is-open')){
    $('html').removeClass('is-open');
    $('body').removeClass('is-fixed').css({'top': 0});
    window.scrollTo(0, pos);
    state = false;
  }
})